/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import $ from 'jquery';
import Component from 'can/component/component';
import Swiper from 'swiper';
import can from 'can';
import dtm from 'scripts/services/dtm';
import template from './championships-selection-tabs.stache';
import DomEventsManager from 'scripts/dom-events-manager';
import appContext from 'scripts/app-context';

const ENTER_KEY_CODE = 13;

Component.extend({
    tag: 'championships-selection-tabs',
    template: template,
    viewModel: {
        isMobile: false,
        isFit: false,
        isLoading: true,
        define: {
            tabs: {
                Type: can.List,
                Value: can.List
            },
            dropDownCollection: {
                Type: can.List,
                Value: can.List
            }
        }
    },
    events: {
        inserted(element) {
            can.route(':section', { tab: '' });
            can.route(':section/:tab', { section: '', tab: '' });
            can.route.ready();
            can.route.bind('section', (ev, tabIndex) => {
                this.updateTabs(tabIndex);
                this.scrollIntoViewIfNeeded(this.element);
                if (tabIndex === 'statistics') {
                    this.updateStatisticsTab();
                } else {
                    can.route.removeAttr('tab');
                }
            });

            can.route.bind('tab', () => {
                if (can.route.attr('section') === 'statistics') {
                    this.updateStatisticsTab()
                }
            });

            this.listenPostMessages();

            DomEventsManager.subscribe(this);
            this.$moreItem = this.element.find('.js-more-item');
            this.$moreDropdownList = this.$moreItem.find('.s-more-dropdown-list');
            this.$tabsContainer = this.element.find('.s-tabs-navigation ');
            this.mobileSlider = null;
            this.iframeUpdateIntervals = [];

            this.awaitRenderTabsContent().then(() => {
                this._tabsContentRendered = true;
                this.element = element;
                this.tabs = element.find('.s-tabs-navigation .s-tabs-navigation-inner__item');
                this.findContentTabs();

                const section = can.route.attr('section');

                if (!section) {
                    const tabs = this.viewModel.attr('tabs');
                    if (tabs && tabs.length) {
                        can.route.attr('section', tabs.attr(0).hashParam);
                    }
                } else {
                    this.updateTabs(section);
                }

                if (section === 'statistics') {
                    this.updateStatisticsTab();
                }
            });
        },

        scrollIntoViewIfNeeded($target, force) {
            if ($target.position()) {
                if ($target.position().top < $(window).scrollTop() || force){
                    $('html, body').animate({ scrollTop: $target.position().top - 100 }, 0);
                }
            }
        },

        updateStatisticsTab() {
            const tab = can.route.attr('tab');
            const container = $('.s-tabs-content__item--statistics');
            const tabs = container.find('.b-selection-tabs__tab');
            const activeTab = container.find('.b-selection-tabs__tab.is-active');
            const tabsContent = container.find('.l-frame-two-columns__column');

            if (!tab && activeTab.length) {
                location.hash = activeTab.attr('href');
                return;
            }

            tabs.removeClass('is-active');
            container.find(`[data-column=${tab}]`).addClass('is-active');
            tabsContent.hide();
            container.find(`.l-frame-two-columns__${tab}`).show();
        },

        '.s-tabs-navigation-inner__item:not(.js-more-item) click': function ($element, event) {
            event.stopPropagation();

            const dataIndex = $element.data('index');
            const dataType = $element.data('type');
            const tabName = $element.text().trim();
            const isSelectedMoreItem = !!$element.closest('.s-more-dropdown-list').length;

            dtm.trackChampionshipsTabClick(tabName, dataType);

            if (dataType === 'link') {
                return;
            }

            this.element.find('.js-more-item ').removeClass('tablet-active');

            if (this._tabsContentRendered && !$element.hasClass('is-selected') && dataIndex) {
                this.viewModel.attr('isSelectedMoreItem', isSelectedMoreItem);
                can.route.attr('section', dataIndex);
            }
        },

        '.js-more-item click': function ($element) {
            if (this.isTablet()) {
                $element.toggleClass('active');
            }
        },

        '.js-more-item keydown': function ($element, event) {
            if (event.keyCode === ENTER_KEY_CODE && !this.isTablet()) {
                    $element.toggleClass('active');
            }
        },

        listenPostMessages() {
            window.addEventListener('message', (event) => {
                if (event.origin !== location.origin) {
                    return;
                }

                if (event.data && event.data.iframe) {
                    if (event.data.iframe === 'scoring') {
                        if (event.data.action === 'search-icon-click') {
                            dtm.trackChampionshipsScoringSearchIconClick();
                        } else if (event.data.action === 'scorecard-round-click') {
                            const roundName = event.data.params.roundName;
                            dtm.trackChampionshipsScoringScorecardRoundClick(roundName);
                        } else if (event.data.action === 'switcher-click') {
                            const switcherName = event.data.params.switcherName;
                            dtm.trackChampionshipsScoringSwitcherClick(switcherName);
                        }
                    } else if (event.data.iframe === 'tee-times') {
                        if (event.data.action === 'search-icon-click') {
                            dtm.trackChampionshipsTeeTimesSearchIconClick();
                        } else if (event.data.action === 'converter-toggle') {
                            const converterName = event.data.params.converterName;
                            dtm.trackChampionshipsTeeTimesConverterToggle(converterName);
                        }
                    }

                    if (event.data.action === 'round-click') {
                        const roundName = event.data.params.roundName;
                        dtm.trackChampionshipsRoundClick(roundName);
                        setTimeout(()=> this.scrollIntoViewIfNeeded(this.element, true), 500);
                    }
                }
            }, false);
        },

        isTablet() {
            return ['small', 'medium', 'large'].indexOf(appContext.model.screen.attr('screenSize')) > -1;
        },

        findContentTabs() {
            let searchContent = () => {
                this.contentTabs = this.element.closest('.l-player-detail').find('.s-tabs-content .s-tabs-content__item');
            };
            let searchInterval = setInterval(() => {
                if (!this.contentTabs || !this.contentTabs.length) {
                    searchContent();
                } else {
                    clearInterval(searchInterval);
                }
            }, 300);
            searchContent();
        },

        awaitRenderTabsContent: function () {
            const awaiter = can.Deferred();

            if (window.CQ && location.search.indexOf('wcmmode=preview') === -1) {
                if (window.CQ.WCM.areEditablesReady()) {
                    awaiter.resolve();
                }
                window.CQ.WCM.addListener('editablesready', () => {
                    awaiter.resolve();
                });
            }
            else {
                awaiter.resolve();
            }

            return awaiter;
        },

        onTabChange: function(el) {
            if (window.CQ) {
                var tabIndex = el.getAttribute('data-index');
                var selected = el.classList.contains('is-selected');
                window.CQ.WCM.USGA.onTabChange(tabIndex, selected);
            }
        },

        updateTabs(tabIndex) {
            if (!tabIndex) {
                return;
            }

            const setIframeHeight = (iframe) => {
                const $wrapper = $(iframe).contents().find('body > div:eq(0)');

                if (!$wrapper.length) {
                    return;
                }

                const newHeight = $wrapper.height() < 200 ? 200 : $wrapper.height() + 40;
                if (newHeight !== $(iframe).height()) {
                    $(iframe).height(newHeight);
                }
            };

            this.tabs = this.element.find('.s-tabs-navigation .s-tabs-navigation-inner__item');
            this.dropdownTabs = this.element.find('.s-more-dropdown-list .s-tabs-navigation-inner__item');
            const changeTab = (element) => {
                const tab = $(element);
                if (tab.attr('data-index') === tabIndex) {
                    this.iframeUpdateIntervals.forEach(clearInterval);
                    this.iframeUpdateIntervals = [];

                    tab.addClass('is-selected').attr('aria-selected', true);
                    const tableIframe = tab.find('.js-tabs-content__iframe:not(.is-loaded)');
                    const tableIframeAll = tab.find('.js-tabs-content__iframe');
                    if (tableIframe.length) {
                        tableIframe.each((index, iframeElement) => {
                            $(iframeElement).attr('src', $(iframeElement).data('src')).addClass('is-loaded');
                        });
                    }
                    if (tableIframeAll.length) {
                        tableIframeAll.each((index, iframeElement) => {
                            this.iframeUpdateIntervals.push(setInterval(() => setIframeHeight(iframeElement), 1000));
                        });
                    }
                } else {
                    tab.removeClass('is-selected').attr('aria-selected', false);
                }
            };
            this.tabs.each((index, element) => {
                changeTab(element);
            });
            this.contentTabs.each((index, element) => {
                changeTab(element);
                this.onTabChange(element);
            });
        },
        checkItemsCount: function () {
            const items = this.element.find('.s-tabs-navigation-inner__item:not(.s-more-item)');

            if (items && !items.length) {
                return;
            }

            const moreItemButtonWidth =  this.$moreItem.outerWidth(true);
            const tabsContainerWidth = this.$tabsContainer.width() - moreItemButtonWidth;
            this.viewModel.attr('dropDownCollection', []);

            let menuItemsWidth = 0;
            let isFit = true;

            items.each((index, element) => {
                if (isFit) {
                    const itemWidth = $(element).outerWidth(true);
                    if ((menuItemsWidth + itemWidth) <= tabsContainerWidth) {
                        menuItemsWidth += itemWidth;
                        let tab = this.viewModel.attr('tabs').attr(index);
                        tab.attr('isHidden', false);
                    } else {
                        isFit = false;
                        let tab = this.viewModel.attr('tabs').attr(index);
                        tab.attr('isHidden', true);
                        this.viewModel.attr('dropDownCollection').push(tab);
                    }
                } else {
                    let tab = this.viewModel.attr('tabs').attr(index);
                    if (tab) {
                        tab.attr('isHidden', true);
                        if (tab.attr('hashParam') == can.route.attr('section')) {
                            tab.attr('isSelected', true);
                            this.viewModel.attr('isSelectedMoreItem', true);
                        }
                        this.viewModel.attr('dropDownCollection').push(tab);
                    }
                }
            });
            this.viewModel.attr('isFit', isFit);

            if (this.viewModel.attr('isLoading')) {
                this.viewModel.attr('isLoading', false);
            }
        },
        setSelectedClass() {
            const section = can.route.attr('section');

            this.viewModel.attr('tabs').each((tab) => {
                if (tab.hashParam == section) {
                    tab.attr('isSelected', true);
                }
            });
        },
        onLayout(screen) {
            setTimeout(() => {
                if (appContext.model.screen.attr('screenSize') === 'extra-small' || appContext.model.screen.attr('screenSize') === 'small') {

                    if (this.mobileSlider) {
                        this.mobileSlider.destroy(true, true);
                        this.mobileSlider = null;
                    }

                    this.viewModel.attr('tabs').each((tab) => {
                        tab.attr('isHidden', false);
                    });

                    this.viewModel.attr('isFit', true);
                    this.viewModel.attr('isMobile', true);
                    this.mobileSlider = new Swiper(this.element.find('.swiper-container'), {
                        slidesPerView: 'auto'
                    });
                    this.viewModel.attr('isLoading', false);
                    this.setSelectedClass();
                } else {
                    setTimeout(() => {
                        this.checkItemsCount();
                    }, 0);
                    this.viewModel.attr('isMobile', false);
                }
            }, 10);
        }
    }
});
